<template>
  <HTableScroll :headers="thead" :rows="channels" class="channels__table">
    <template #row="{ row }">
      <td>
        <CChannelSla :channel="row" />
      </td>
      <td>
        {{ formatDate(row.createdAt) }}
      </td>
      <td>
        <CDemandTag
          v-if="row.demands && row.demands.length"
          :demands="row.demands"
        />
        <WTag v-else color="gray" label="Sem demanda" size="large" />
      </td>
      <td>
        <WButton
          variant="tertiary"
          icon-button
          icon="icLink"
          @click="e => goToChannel(row, e)"
        />
      </td>
    </template>
  </HTableScroll>
</template>
<script>
import { WButton, WTag } from '@alice-health/wonderland-vue'

import { HTableScroll } from '@/components/shared/atoms'
import { toLocalDate } from '@/utils/date'

import { CChannelSla, CDemandTag } from '..'

export default {
  components: { CDemandTag, WButton, WTag, CChannelSla, HTableScroll },
  props: {
    channels: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      thead: [
        {
          title: 'SLA'
        },
        {
          title: 'Criação'
        },
        {
          title: 'Demanda'
        },
        {
          title: 'Url'
        }
      ]
    }
  },
  methods: {
    goToChannel(channel, e) {
      const personId = channel.personId
      const routerPath = `/member/${personId}/pillars?channelId=${channel.id}`
      if (e.ctrlKey || e.metaKey) {
        window.open(routerPath, '_blank')
        return
      }
      this.$router.push(routerPath)
    },
    formatDate(date) {
      return toLocalDate(date)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/style/_non-rendering';
.channels__table {
  max-height: 80%;
}
</style>
